import { PaymentTransactionStatusHistory } from "./paymentTransactionStatusHistory";

export class PaymentTransaction {
    id: string;
    transactionId : string;
    paymentMeanId : string;
    paymentId : string;
    externalId : string;
    transactionReference : string;
    orderId : string;
    maskedPan : string;
    walletId : string;
    merchantId : number;
    merchantRef : string;
    merchantExtRef? : string;
    endToEndId : string;
    authorizedAmount : number;
    capturedAmount : number;
    refundAmount : number;
    currency : string;
    createdDate : string;
    completionDate : string;
    errorCode : string;
    status: string;
    paymentTransactionStatusHistory: Array<PaymentTransactionStatusHistory>;
    paymentTransactionProvider : string;
    createdBy : string;
    liabilityShift : Boolean;
}
